import { QueryClient } from '@tanstack/react-query';

import { isApiError } from '@/lib/errors';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount, error) => {
        // Never retry auth failures; retry transient errors up to twice.
        if (isApiError(error) && (error.isAuth || error.status === 0)) {
          return false;
        }
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
  },
});
